export enum ThemeTypes {
  LIGHT = "light",
  DARK = "dark",
}

export interface AppTheme {
  theme: ThemeTypes | string;
}
